import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Formik, Form, Field } from "formik";
import { otpVerification, resendOtp } from "../../services/auth.services";
import { Link, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { SWAL_SETTINGS } from "../../../../utils/Constants";
import Swal from "sweetalert2";
import { globalLoader, handleServerValidations } from "../../../../utils/commonfunction";
import OtpInput from "react-otp-input";
import { useValidationSchemas } from "../../validator/validation";
import logowide from '../../../../assets/center/images/logo-h.png'
import { DoctorOtpVerification, DoctorResendOtp } from "../../../doctor/services/auth.services";

function Verifyotp() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const { state } = useLocation();
  const [otp, setOtp] = useState("");
  const { otpValidationSchema } = useValidationSchemas();
  const [resendDisabled, setResendDisabled] = useState(false);
  const [counter, setCounter] = useState(0);
  const [searchParams] = useSearchParams();
  const userType = searchParams?.get("select_role");

  const initialValues = {
    otp: "",
  };

  useEffect(() => {
    if (location?.state?.select_role === "center") {
      if (!state?.email || state?.email.length === 0) {
        navigate("/center/login");
      }
    } else {
      if (!state?.email || state?.email.length === 0) {
        navigate("/doctor/login");
      }
    }
    let timer;
    if (counter > 0) {
      timer = setTimeout(() => setCounter(counter - 1), 1000);
    } else {
      setResendDisabled(false);
    }
    return () => clearTimeout(timer);
  }, [counter]);

  const handleSubmit = async (values, actions) => {
    const otpValue = values.otp;
    console.log(otpValue);
    globalLoader(true);
    try {
      await otpValidationSchema.validate(values, { abortEarly: false });
      let formData = new FormData();
      formData.append("email", state?.email);
      formData.append("otp", otpValue);
      formData.append("role", location?.state?.select_role);
      formData.append("type", "password_reset");

      if (location?.state?.select_role === "center") {
        await otpVerification(formData)
          .then((response) => {
            globalLoader(false);
            if (response.success && location.pathname.includes("otp-verification")) {
              Swal.fire({
                icon: "success",
                text: response.message,
                ...SWAL_SETTINGS,
              });
              navigate("/center/reset-password", {
                state: {
                  select_role: location?.state?.select_role,
                  validate_string: response?.data?.validate_string
                }
              });

            } else {
              Swal.fire({
                icon: "error",
                text: handleServerValidations(response),
                ...SWAL_SETTINGS,
              });
            }
          })
          .catch((error) => {
            console.log("error: ", error);
          });
      } else {
        await DoctorOtpVerification(formData)
          .then((response) => {
            globalLoader(false);
            if (response.success && location.pathname.includes("otp-verification")) {
              Swal.fire({
                icon: "success",
                text: response.message,
                ...SWAL_SETTINGS,
              });
              navigate("/doctor/reset-password", {
                state: {
                  select_role: location?.state?.select_role,
                  validate_string: response?.data?.validate_string
                }
              });

            } else {
              Swal.fire({
                icon: "error",
                text: handleServerValidations(response),
                ...SWAL_SETTINGS,
              });
            }
          })
          .catch((error) => {
            console.log("error: ", error);
          });
      }
    } catch (error) {
      console.log(error);
      actions.setErrors({});
    } finally {
      globalLoader(false);
      actions.setSubmitting(false);
    }
  };


  const handleResend = async () => {
    globalLoader(true);
    setResendDisabled(true);
    setCounter(30);
    let formData = new FormData();
    formData.append("email", state?.email);
    formData.append("role", location?.state?.select_role);
    formData.append("type", "restaurant_password_reset");
    if (location?.state?.select_role == 'center') {
      resendOtp(formData)
        .then((response) => {
          globalLoader(false);
          if (response.success) {
            Swal.fire({
              icon: "success",
              text: response.message,
              ...SWAL_SETTINGS,
            });
          } else {
            Swal.fire({
              icon: "error",
              text: response.message,
              ...SWAL_SETTINGS,
            });
          }
        })
        .catch((error) => {
          globalLoader(false);
          console.log("error: ", error);
        });
    } else {
      DoctorResendOtp(formData)
        .then((response) => {
          globalLoader(false);
          if (response.success) {
            Swal.fire({
              icon: "success",
              text: response.message,
              ...SWAL_SETTINGS,
            });
          } else {
            Swal.fire({
              icon: "error",
              text: response.message,
              ...SWAL_SETTINGS,
            });
          }
        })
        .catch((error) => {
          globalLoader(false);
          console.log("error: ", error);
        });
    }
  };

  return (
    <div className="auth-body d-flex align-items-center justify-content-center">
      <div className="auth-box">
        <div className="form-box-inner d-flex flex-column gap-5">
          <div className="form-logo">
            <img src={logowide} />
          </div>
          <div className="form-card">
            <div className="form-text">
              <h5 className="mt-2">{t("center.otp_verification.heading")}</h5>
              <p>{t("center.otp_verification.description")}</p>
            </div>
            <Formik initialValues={initialValues} onSubmit={handleSubmit} validationSchema={otpValidationSchema}>
              {({ errors, touched, setFieldValue }) => (
                <Form>
                  <div className={`d-flex w-100 justify-content-between ${errors.otp && touched.otp ? '' : 'mb-4'}`}>
                    <div className="col-md-3 number-otp-section">
                      <Field name="otp">
                        {({ field }) => (
                          <OtpInput
                            {...field}
                            value={otp}
                            inputType="number"
                            onChange={(value) => {
                              setOtp(value);
                              setFieldValue("otp", value);
                            }}
                            numInputs={4}
                            separator={<span>-</span>}
                            renderInput={(props, index) => (
                              <input
                                {...props}
                                key={index}
                                className="form-control"
                                style={{ width: "6rem", marginRight: "10px", textAlign: "center", fontWeight: 600 }}
                                maxLength="1"
                                autoFocus={index === 0 ? true : false}
                                placeholder="-"
                              />
                            )}
                          />
                        )}
                      </Field>
                    </div>
                  </div>
                  {errors.otp && touched.otp && <div className="text-danger mb-4">{errors.otp}</div>}

                  {/* <button className={"btn btn-primary justify-content-center"} type="submit">
                    {t("center.otp_verification.verify_otp")}
                  </button> */}
                  <button type="submit" className={"btn btn-primary w-100"}>
                    {t("center.otp_verification.verify_otp")}
                  </button>
                </Form>
              )}
            </Formik>
            <div className="login-cta-bottom mt-3">
              <p>
                {t("center.otp_verification.otp_not_receive")}{" "}
                <a
                  className={`${resendDisabled ? " disabled" : ""}`}
                  onClick={(e) => {
                    e.preventDefault();
                    if (!resendDisabled) {
                      handleResend();
                    }
                  }}
                  href="/"
                >
                  {t("center.otp_verification.btn_resend")}
                </a>
                {resendDisabled && <span className="text-secondary ms-2">({counter})</span>}
              </p>
            </div>
          </div>
          <div className="d-flex justify-content-center">
            <div className="back-text  d-flex gap-2 align-items-center">
              <i className="ti ti-arrow-left"></i>
              <Link
                class="link-text"
                to={`/${location?.state?.select_role}/forget-password`}
                state={{ select_role: location?.state?.select_role }}
              >
                Back to Forgot Password
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Verifyotp;
